module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal5-4150d2caadc323e2ff329fa7db0ebb4f.jpg";